// extracted by mini-css-extract-plugin
module.exports = {"noteTag":"noteTag_noteTag__1Csbd","condense":"noteTag_condense__1D1JC","poke":"noteTag_poke__160wp"};